module.exports = __webpack_public_path__ + "img/jaq.cc8cbec0.png";